var lib_core = require("lib-core");

var TrayAssetUpdateTabView         = require("./trayAssetUpdateTabView.js");
var TrayAssetUpdateTabModel        = require("./trayAssetUpdateTabModel.js");
var TrayAssetUpdateTabStateMachine = require("./trayAssetUpdateTabStateMachine.js");

var TrayTabsController = require('./../tray_tabs/trayTabsController.js');

var TrayAssetUpdateTabController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        UI_TRAY_TAB_SORT: {id: 'ui_tray_tab_01', name: "UI_TRAY_TAB_SORT" },
        UI_TRAY_TAB_SEARCH: {id: 'ui_tray_tab_02', name: "UI_TRAY_TAB_SEARCH" },
        UI_TRAY_TAB_TEMPLATE_CHANGE: {id: 'ui_tray_tab_03', name: "UI_TRAY_TAB_TEMPLATE_CHANGE" }
    });

};
lib_core.inherit(TrayAssetUpdateTabController, lib_core.Controller);
TrayAssetUpdateTabController.inject = {
    trayTabsController : TrayTabsController
};

module.exports = TrayAssetUpdateTabController;

TrayAssetUpdateTabController.prototype.beforeLoad = function() {

    // Store config options in model
    this.getModel().collection = this.root.data.findByPath(this.configuration.collection);
    this.getModel().name(this.name() || "");
    this.getModel().title(this.configuration.title || "");
    this.getModel().template(this.configuration.template || "");
    this.getModel().alternative_template(this.configuration.alternative_template || false);
    this.getModel().type(this.configuration.type || "");
    this.getModel().default_query_fields(this.configuration.owned_only ? "user_id="+this.root.contentServerClient.getUserId() : "");

    this.getModel().reload();

    lib_core.Controller.prototype.beforeLoad.call(this);
};

TrayAssetUpdateTabController.prototype.createView = function () {
    var parentName = this.trayTabsController.name();

    var view = new TrayAssetUpdateTabView(this.getModel(), this.getStatemachine(), this.rootStateMachine, this.trayTabsController.getView(), parentName);

    // Register tab to tabsController
    this.trayTabsController.registerTab(this.getModel(), parentName);

    return view;
};

TrayAssetUpdateTabController.prototype.createModel = function () {
    return new TrayAssetUpdateTabModel(this.rootStateMachine);
};

TrayAssetUpdateTabController.prototype.createStateMachine = function () {
    var parentName = this.trayTabsController.name();
    return new TrayAssetUpdateTabStateMachine(this.root, this.getModel(), parentName);
};
